import * as actionTypes from './actionTypes';

export const PanelTabs = {
    my_vehicle: 'my_vehicle',
    offers: 'offers',
    appointments: 'appointments'
}

// export const setActivePanelTab = (tab) => {
//     return {
//         type: actionTypes.SET_ACTIVE_PANEL_TAB,
//         tab: tab
//     };
// }

// export const resetActivePanelTab = () => {
//     return {
//         type: actionTypes.RESET_ACTIVE_PANEL_TAB
//     }
// }

export const updatePanelTab = (tab, expanded) => {
    return {
        type: actionTypes.UPDATE_PANEL_TAB,
        tab: tab,
        expanded: expanded
    }
}

export const expandAllTabs = (expanded) => {
    return {
        type: actionTypes.EXPAND_ALL_TABS,
        expanded: expanded
    }
}

export const expandTabOnly = (tab) => {
    return {
        type: actionTypes.EXPAND_TAB_ONLY,
        tab: tab
    }
}


export const updateTabOnly = (tab, expanded) => {
    return (dispatch) => {
        if (expanded) {
            dispatch(expandAllTabs(false));
        }
        dispatch(updatePanelTab(tab, expanded));
    }
}